import type { StringKey } from './en';

/** Spanish customer-facing copy (usted, consistent with the rest of the funnel). Plain punctuation: no em dashes. */
export const es: Record<StringKey, string> = {
  brandSub: 'Mudanzas y almacenaje · Florida',
  langSwitch: 'English',
  langSwitchAria: 'Switch to English',
  callKyle: 'Llame y reserve ahora',
  aiLabel: 'Atención telefónica',
  humanHelp: 'Hablar con una persona',
  callShort: 'Llamar',
  homeTitle1: '¿Se muda en Florida?',
  homeTitle2: 'Reserve desde su teléfono.',
  homePick: 'Elija su hogar para empezar.',
  preferTalk: '¿Prefiere hablar?',
  homeSub: 'Elija su hogar, agregue sus artículos, seleccione sus servicios y reserve en línea. Sin necesidad de llamar. ¿Prefiere hablar? Llámenos y le ayudamos.',
  homeSubPreview: 'Elija su hogar, agregue sus artículos, seleccione sus servicios y vea su estimado detallado en línea. Sin necesidad de llamar. ¿Prefiere hablar? Llámenos y le ayudamos.',
  homeSteps: 'Elija su mudanza. Revise sus precios. Firme en línea. Reserve de forma segura.',
  homeStepsPreview: 'Elija su mudanza. Revise sus precios. Envíe su plan. Confirmamos con usted los documentos y el depósito.',
  promise: 'Configure y reserve su mudanza desde su teléfono. Sin necesidad de llamar. Le ayudamos cuando prefiera hablar.',
  promisePreview: 'Configure su mudanza y vea su estimado desde su teléfono. Sin necesidad de llamar. Le ayudamos cuando prefiera hablar.',
  homeArea: 'Tampa, Orlando, Ocala, Sarasota y rutas aprobadas en Florida.',
  homeAreaDetail: 'Revisamos la recogida, la entrega y cada parada según nuestra área de servicio mientras planea.',
  card1: 'Estudio / 1 recámara',
  card2: '2 recámaras',
  card3: '3 recámaras',
  card4: '4 recámaras',
  crewHint2: 'Normalmente 2 trabajadores',
  crewHint23: '2 o 3 trabajadores',
  crewHint3: 'A menudo 3 trabajadores',
  crewHint3r: '3 trabajadores, lo revisamos con usted',
  more5: '5+ recámaras',
  fewItems: 'Solo unos cuantos artículos',
  ctaBuild: 'Armar mi mudanza',
  howTitle: 'Cómo funciona',
  how1: 'Cuéntenos sobre su mudanza',
  how1Body: 'Habitaciones, direcciones, escaleras o elevador y lo que va a mudar.',
  how2: 'Revise su estimado',
  how2Body: 'Equipo, horas estimadas y cada cargo detallado antes de decidir.',
  how3: 'Firme y reserve con $99',
  how3Body: 'El depósito se acredita a su factura final.',
  how3Preview: 'Envíe su plan',
  how3PreviewBody: 'Nuestro equipo confirma con usted la disponibilidad, los documentos y su depósito de $99.',
  ratesTitle: 'Tarifas por hora',
  rate2: '2 trabajadores + 1 camión',
  rate3: '3 trabajadores + 1 camión',
  perHour: '/hora',
  ratesNote: 'Mínimo de 4 horas de servicio, más 1 hora de traslado y un recargo operativo del 20%. Los pagos con tarjeta tienen un cargo del 4%. Empaque y materiales se cotizan aparte.',
  helpQuick: 'Respuestas rápidas',
  stepSize: 'Hogar',
  stepAddresses: 'Direcciones',
  stepAccess: 'Acceso',
  stepInventory: 'Inventario',
  stepPacking: 'Empaque y camión',
  stepDate: 'Fecha',
  stepContact: 'Contacto',
  stepEstimate: 'Estimado',
  stepReserve: 'Reservar',
  stepStatus: 'Estado',
  back: 'Atrás',
  next: 'Continuar',
  acceptContinue: 'Aceptar estimado y continuar',
  summary: 'Su mudanza',
  close: 'Cerrar',
  saved: 'Progreso guardado en este dispositivo',
  editDetails: 'Editar',
  sizeTitle: '¿Qué va a mudar?',
  typeLabel: 'Tipo de propiedad',
  htApartment: 'Apartamento',
  htHouse: 'Casa',
  htTownhome: 'Townhouse',
  htOffice: 'Oficina / mudanza especial',
  bedTitle: '¿Cuántas recámaras?',
  bedStudio: 'Estudio',
  bedOne: '1 recámara',
  bedMany: '{n} recámaras',
  bed5: '5+ recámaras',
  bedFew: 'Solo unos cuantos artículos',
  adNote: 'Empezamos con el tamaño de su anuncio. Cámbielo cuando quiera.',
  suggestTitle: 'Artículos comunes para este hogar',
  suggestBody: 'Toque para agregar lo que realmente tiene. No se agrega nada a menos que usted lo elija.',
  addAll: 'Agregar todas las sugerencias',
  added: 'Agregado',
  addrTitle: '¿A dónde se muda?',
  addrIntro: 'Recogida y entrega. Mantenga el apartamento, el edificio y el complejo separados de la dirección.',
  fromLabel: 'Recogida',
  toLabel: 'Entrega',
  streetLabel: 'Dirección',
  unitLabel: 'Apto / unidad',
  zipLabel: 'Código postal',
  addrManual: 'Las direcciones escritas aún no están verificadas. Nuestro equipo las revisa antes de cualquier reserva.',
  zoneIncomplete: 'Escriba el código postal de cada lugar para revisar la cobertura.',
  zoneCore: 'Esta ruta está en nuestra área principal alrededor de Tampa, Orlando, Ocala y Sarasota. Confirmamos la ruta exacta antes de reservar.',
  zoneCorridor: 'Esta es una de nuestras rutas largas en Florida. Puede reservar en línea y nuestro equipo agrega un estimado de transporte antes de que pague.',
  zoneCorridorSmall: 'Las rutas largas en Florida se reservan en línea para 2 recámaras o más. Continúe y nuestro equipo revisará opciones para su mudanza.',
  zoneMiami: 'Las mudanzas a Miami de 2 a 4 recámaras se pueden reservar en línea. Nuestro equipo agrega un estimado de transporte antes de que pague.',
  zoneMiamiSmall: 'Para Miami, la reserva en línea es para 2 a 4 recámaras. Continúe y nuestro equipo revisará opciones para su mudanza.',
  zonePending: 'Parte de esta ruta necesita una revisión de cobertura antes de reservar. Continúe y guardamos su plan.',
  zonePanhandle: 'No tomamos reservas en línea para Tallahassee, Panama City ni el Panhandle. Continúe y nuestro equipo revisará opciones con usted.',
  zoneOutside: 'Esta ruta está fuera de nuestra área de servicio en Florida. Continúe y nuestro equipo revisará opciones con usted. No se cobra depósito.',
  zoneLarge: 'Los hogares de 5 recámaras o más los revisa nuestro equipo antes de reservar.',
  accessTitle: 'Acceso en la recogida y la entrega',
  accessIntro: 'Escaleras, elevadores, estacionamiento y distancia a pie cambian el tiempo y el equipo. “Planta baja” significa a nivel de la calle.',
  originHome: 'Recogida',
  destHome: 'Entrega',
  floorLabel: '¿En qué nivel está?',
  flGround: 'Planta baja (nivel de la calle)',
  flSecond: '2.º piso (EE. UU.)',
  flThird: '3.er piso (EE. UU.)',
  flFourth: '4.º piso o más',
  methodLabel: '¿Cómo se llega?',
  mStairs: 'Escaleras',
  mPassenger: 'Elevador de pasajeros',
  mFreight: 'Elevador de carga / servicio',
  flightsLabel: 'Tramos de escaleras',
  elevResLabel: '¿Hay que reservar el elevador?',
  sharedElevLabel: '¿Se comparte con residentes durante la mudanza?',
  truckNearLabel: '¿El camión puede estacionarse legalmente cerca de la entrada?',
  gateLabel: '¿Código de acceso o restricciones de HOA?',
  coiLabel: '¿El edificio exige un certificado de seguro (COI)?',
  parkingLabel: '¿Dónde puede estacionarse legalmente el camión?',
  pkDriveway: 'Entrada de la casa',
  pkStreet: 'Calle',
  pkLot: 'Estacionamiento',
  pkDock: 'Muelle de carga',
  pkUnsure: 'No sé',
  innerCarryLabel: 'Distancia adicional adentro: pasillos, hasta el elevador o del elevador a la puerta',
  restrictionsLabel: 'Restricciones de acceso del edificio (opcional)',
  loadingHoursLabel: 'Límites de horario para estacionar o cargar (opcional)',
  yes: 'Sí',
  no: 'No',
  unsure: 'No sé',
  carryLabel: 'Distancia del camión a la entrada del edificio',
  carryHelp: 'Una respuesta aproximada está bien. No incluya la altura de los pisos.',
  cb0_20: '0–20 pies',
  cb21_40: '21–40 pies',
  cb41_60: '41–60 pies',
  cb61_100: '61–100 pies',
  cbover_100: 'Más de 100 pies',
  cbunsure: 'No sé',
  car1: '≈ 1 largo de auto',
  car2: '≈ 2 largos de auto',
  car4: '≈ 4 largos de auto',
  car6: '≈ 4–7 largos de auto',
  car7: 'más de 7',
  carNone: 'medir después',
  carNote: 'Un sedán compacto mide unos 15 pies. Solo aproximado.',
  feetLabel: 'Pies exactos (opcional)',
  accessNotesLabel: 'Algo más para despacho (límites para camión, color de la casa, indicaciones)',
  invTitle: '¿Qué vamos a mudar?',
  invIntro: 'Elija artículos por habitación. Las sugerencias son solo ideas. Usted decide qué se incluye.',
  suggested: 'Sugerido',
  addSuggestedRoom: 'Agregar sugerencias de esta habitación',
  invItems: '{n} artículos',
  decrease: 'Disminuir',
  increase: 'Aumentar',
  addItemLabel: 'Agregar otro artículo',
  addItemPlaceholder: 'ej. caminadora, acuario',
  addItemBtn: 'Agregar',
  remove: 'Quitar',
  invUnsure: 'Aún no estoy seguro. Ayúdenme a confirmar la lista.',
  disassembly: 'Camas u otros muebles necesitan desarmarse y armarse',
  specialTitle: 'Artículos pesados, frágiles o especiales',
  specialHelp: 'Estos reciben una revisión rápida para traer el equipo y el precio adecuados.',
  invNotes: 'Notas sobre sus artículos',
  errInventory: 'Agregue al menos un artículo, o indíquenos que aún no está seguro',
  packTitle: 'Empaque',
  packSelf: 'Solo mudanza. Tendré todo empacado.',
  packSelfBody: 'Usted empaca las cajas. El equipo igual acolcha y envuelve los muebles.',
  packPro: 'Mudanza con empaque profesional.',
  packProBody: 'Nuestro equipo empaca con cajas adecuadas, divisores y etiquetas. El servicio de empaque y los materiales se cotizan aparte.',
  packPrepNote: 'Tener las cajas listas y los muebles preparados, o ya desarmados, normalmente reduce el tiempo de servicio.',
  protectTitle: 'Empaque cuidadoso para lo que quiere conservar',
  protect1: 'Mantas acolchadas ajustadas a los muebles',
  protect2: 'Esquinas y bordes reforzados',
  protect3: 'Cajas del tamaño adecuado para cada artículo',
  protect4: 'Divisores que mantienen los platos en vertical',
  protect5: 'Pisos y puertas protegidos',
  protect6: 'Etiquetas claras para desempacar fácil',
  protectNote: 'El mismo cuidado en una mudanza local que en una larga.',
  packProductsTitle: 'Elija ayuda de empaque y materiales',
  pricedByTeam: 'Precio fijado por nuestro equipo',
  packTimeNote: 'El empaque agrega tiempo el día de la mudanza. Lo incluimos en el horario del equipo.',
  dateTitle: '¿Cuándo le gustaría mudarse?',
  dateLabel: 'Fecha solicitada',
  dateUnsure: 'Aún no estoy seguro de la fecha',
  arrivalLabel: 'Horario de llegada preferido',
  arr8: '8 AM',
  arrNoon: 'Mediodía',
  arr3: '3 PM',
  arrOther: 'Otra hora',
  arrOtherLabel: '¿Qué hora le funciona?',
  arrivalNote: 'Es su fecha y horario solicitados. El horario de llegada, el equipo y el camión los confirma despacho después de reservar.',
  anotherTimeCopy: '¿Necesita otra hora? Díganos y revisamos si se puede conseguir capacidad adicional. Sigue siendo una solicitud hasta que la confirmemos.',
  contactTitle: '¿A dónde enviamos su estimado?',
  firstName: 'Nombre',
  lastName: 'Apellido',
  phone: 'Celular',
  email: 'Correo electrónico',
  channelLabel: 'Mejor forma de contactarle',
  chCall: 'Llamada',
  chText: 'Mensaje de texto',
  chEmail: 'Correo',
  consentQuote: 'Acepto que InstaMovers Florida LLC use estos datos para preparar y dar seguimiento a mi cotización por llamada o correo electrónico.',
  consentAi: 'Pueden llamarme sobre esta mudanza, incluso desde la línea con asistencia de IA de InstaMovers Florida LLC. Esto es independiente de los mensajes de texto.',
  consentOptional: 'Opcional',
  consentRequired: 'Obligatorio',
  errRequired: 'Este campo es obligatorio',
  errPhone: 'Ingrese un celular de EE. UU. de 10 dígitos',
  errEmail: 'Ingrese un correo válido',
  errConsent: 'Acepte para que podamos preparar su cotización',
  errZip: 'Ingrese un código postal de 5 dígitos',
  errDate: 'Elija una fecha, o indíquenos que aún no está seguro',
  errArrival: 'Elija una hora de llegada',
  errPayer: 'Ingrese el nombre y correo de quien paga',
  estTitle: 'Su estimado de mudanza',
  estSub: 'Estimado por hora, no es un precio fijo. Su factura final se basa en el tiempo real de servicio y los cambios que usted apruebe.',
  priceClear: 'Precios claros y detallados antes de reservar.',
  crewLabel: 'Equipo',
  moversN: '{n} trabajadores',
  recommended: 'Recomendado',
  yourChoice: 'Su elección',
  crewPrefLabel: 'Tamaño del equipo',
  crewRec: 'Recomendado ({n})',
  crew2: '2 trabajadores',
  crew3: '3 trabajadores',
  crewPrefNote: 'Nuestro equipo confirma que {n} trabajadores pueden hacerlo con seguridad antes de la mudanza.',
  serviceLabel: 'Tiempo de servicio estimado',
  hoursRange: '{a}–{b} horas',
  hoursN: '{n} h',
  minimumNote: 'Aplica un mínimo de 4 horas de servicio',
  rateLabel: '{n} trabajadores + 1 camión',
  lineRate: 'Tarifa por hora',
  lineService: 'Tiempo de servicio (estimado)',
  lineTravel: 'Traslado (de la base a su mudanza y regreso)',
  lineLabor: 'Mano de obra + traslado',
  lineSurcharge: 'Recargo operativo (20%)',
  surchargePending: 'Aún no se muestra: se está confirmando sobre qué monto se calcula',
  lineCardFee: 'Cargo por pago con tarjeta ({p}%)',
  cardFeeNote: 'Aplica solo a lo que se paga con tarjeta',
  lineTransport: 'Transporte para rutas largas',
  transportValue: 'Lo estima nuestro equipo antes de que pague',
  lineTotal: 'Total estimado',
  totalPending: 'Se muestra cuando el recargo operativo esté configurado',
  totalRange: 'Mano de obra, traslado y cargo de tarjeta hasta ahora: {a} – {b}',
  linePacking: 'Empaque y materiales',
  lineDeposit: 'Depósito a pagar ahora',
  depositCredit: 'Se acredita a su factura final. No es un cargo adicional.',
  lineRemaining: 'Restante estimado',
  remainingNote: 'Antes del recargo operativo y extras. Su factura final sigue el tiempo real y los cambios aprobados.',
  rateByTeam: 'Fijada por nuestro equipo para este tamaño de equipo',
  reviewTitle: 'Nuestro equipo revisará algunos detalles',
  rr_zone: 'Su ruta necesita una revisión del área de servicio',
  rr_transport: 'Las rutas largas necesitan un estimado de transporte. La hora de traslado mostrada cubre solo el traslado local.',
  rr_special: 'Los artículos especiales requieren el equipo y el precio adecuados',
  rr_bigInventory: 'Su inventario es mayor de lo típico para este tamaño de hogar',
  rr_large: 'Los hogares grandes reciben revisión de equipo y camión',
  rr_elevator: 'El acceso por elevador requiere una revisión rápida',
  rr_stairsHigh: 'Un 4.º piso o más por escaleras requiere planeación',
  rr_longCarry: 'Una caminata de más de 100 pies requiere revisión',
  rr_crewPref: 'Confirmaremos que su elección de equipo es segura para esta mudanza',
  rr_stops: 'Las paradas adicionales agregan tiempo de manejo y carga. Nuestro equipo planifica la ruta con usted.',
  rr_variantReview: 'Uno o más artículos (cubiertas de vidrio o piedra, televisores muy grandes) requieren revisión de manejo.',
  rr_truckSmall: 'El camión que eligió podría quedar pequeño para su lista. Nuestro equipo le sugerirá un ajuste.',
  cr_1: 'Dos trabajadores normalmente manejan bien un estudio o 1 recámara, incluso con escaleras.',
  cr_2: 'Dos trabajadores son adecuados para la mayoría de mudanzas de 2 recámaras en planta baja o 2.º piso.',
  cr_2_third: 'Para 2 recámaras hasta un 3.er piso por escaleras, tres trabajadores cargan con más seguridad y terminan antes.',
  cr_3: 'Tres trabajadores mueven con seguridad las piezas pesadas en la mayoría de mudanzas de 3 recámaras. Dos pueden funcionar con una lista más ligera y bien preparada.',
  cr_3_upper: 'Con escaleras en pisos altos, 3 recámaras van más seguras y rápidas con tres trabajadores.',
  cr_45: 'Los hogares grandes empiezan con tres trabajadores. Revisamos si conviene más ayuda.',
  cr_elevator: 'El tiempo de elevador depende del edificio. Revisamos el acceso para planear el equipo correcto.',
  cr_stairsHigh: 'Cuatro o más tramos de escaleras requieren planeación. Nuestro equipo confirma el personal.',
  acceptNote: 'Al aceptar se guarda esta versión del estimado. Si cambia algo después, le pediremos revisarlo de nuevo.',
  reserveTitle: 'Revise y reserve',
  reserveIntro: 'Esto es lo que aplica a su reserva antes de cualquier pago.',
  staleTitle: 'Su estimado cambió',
  staleBody: 'Editó su mudanza después de aceptar el estimado. Revise la versión actualizada.',
  staleBtn: 'Revisar estimado actualizado',
  versionLabel: 'Versión del estimado',
  docsTitle: 'Documentos para esta reserva',
  docBooking: 'Contrato de reserva y términos',
  docDeposit: 'Autorización de tarjeta para el depósito',
  docThird: 'Autorización del titular de tarjeta (tercero)',
  docFull: 'Autorización del saldo total',
  docBol: 'Conocimiento de embarque (Bill of Lading)',
  whoYou: 'Usted',
  whoCardholder: 'Titular de la tarjeta',
  whoPayer: 'Quien paga',
  whenNow: 'Antes de reservar',
  whenLater: 'El día de la mudanza',
  docStatusNot: 'Nuestro equipo los envía para firma segura',
  payerTitle: '¿Quién paga?',
  payerMe: 'Yo pago',
  payerOther: 'Otra persona paga',
  payerName: 'Nombre completo de quien paga',
  payerEmail: 'Correo de quien paga',
  payerPhone: 'Celular de quien paga (opcional)',
  methodTitle: 'Método de pago',
  payCard: 'Tarjeta',
  payZelle: 'Zelle',
  zelleNote: 'Nuestro equipo comparte los datos de Zelle. Después de enviarlo, una persona del equipo lo verifica con el banco. Aparece como “Verificación de Zelle pendiente” hasta entonces.',
  cancelTitle: 'Cambios y cancelación',
  cancelBody: 'Puede cancelar o cambiar su fecha con al menos 72 horas de aviso. Los términos exactos de reembolso están en su contrato de reserva, que verá antes de pagar.',
  reserve99: 'Reservar con $99',
  prepay: 'Prepagar mi mudanza estimada',
  notAvailable: 'Aún no disponible en línea',
  requestEstimate: 'Enviar mi plan de mudanza',
  requestNote: 'Revisaremos su plan y le contactaremos para confirmar disponibilidad, documentos y su depósito de $99.',
  submitting: 'Enviando…',
  submitError: 'Algo falló al enviar su solicitud. Sus respuestas están guardadas. Intente de nuevo o llámenos.',
  retry: 'Intentar de nuevo',
  statusTitle: 'Su solicitud',
  previewBanner: 'Modo de vista previa: esta solicitud está guardada solo en este dispositivo y aún no ha llegado a nuestro equipo. Llame para completarla.',
  liveReceived: 'Solicitud recibida. Nuestro equipo le contactará.',
  refLabel: 'Referencia',
  rowEstimate: 'Estimado',
  rowDocuments: 'Documentos',
  rowDeposit: 'Depósito',
  rowDispatch: 'Despacho',
  stAccepted: 'Aceptado por usted',
  stDocsNot: 'Sin firmar. Nuestro equipo los envía.',
  stDepNot: 'No pagado',
  stDepZelle: 'No pagado. Zelle lo verifica nuestro equipo.',
  stDispatch: 'Fecha solicitada. Horario de llegada, equipo y camión aún sin confirmar.',
  nextTitle: 'Qué sigue',
  next1: 'Nuestro equipo revisa sus direcciones, acceso y artículos.',
  next2: 'Confirmamos con usted la fecha, el equipo y los documentos.',
  next3: 'Su mudanza se confirma solo cuando documentos, depósito y despacho estén completos.',
  newMove: 'Iniciar otra mudanza',
  footerScope: 'Mudanzas en Tampa, Orlando, Ocala, Sarasota y rutas aprobadas en Florida.',
  footerStaff: 'Consola del equipo',
  footerLegal: 'IMF Florida Local Movers es un servicio de InstaMovers Florida.',
  callFloating: 'Llame y reserve ahora',
};
